import { DateTime } from 'luxon';
export const birthday = (date) => {
    const today = new Date();
    const birthday = new Date(date);
    let age = today.getFullYear() - birthday.getFullYear();
    const month = today.getMonth() - birthday.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthday.getDate())) {
        age -= 1;
    }
    return age;
};
export const formattedDate = (date, format = 'YYYY-MM-DD') => {
    // Try ISO format first, then fall back to SQL datetime format
    let dateTime = DateTime.fromISO(date);
    if (!dateTime.isValid) {
        // Handle SQL datetime format: "YYYY-MM-DD HH:mm:ss"
        dateTime = DateTime.fromSQL(date);
    }
    if (!dateTime.isValid) {
        // Last resort - try to parse as a generic format
        dateTime = DateTime.fromFormat(date, 'yyyy-MM-dd HH:mm:ss');
    }
    return dateTime.isValid ? dateTime.toFormat(format) : 'Invalid date';
};
export const formattedDateTime = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
    return DateTime.fromISO(date).toFormat(format);
};
